import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import localforage from 'localforage';
import appRoutes from '../app/appRoutes';
import { externalRoutes } from '../settings';

const ProtectRoute = ({ children }) => {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(null);

  useEffect(() => {
    const credentials = JSON.parse(localStorage.getItem('credentials'));
    if (!credentials || !credentials.accessToken) {
      window.location.href = externalRoutes.login;
      // navigate(externalRoutes.login, { replace: true });
    } else {
      setAuthenticated(true);
    }
  }, [navigate]);

  if (authenticated === null) return null;
  return authenticated ? children : null;
};

export default ProtectRoute;
